import styled from 'styled-components';
import { measures } from '../../theme/measures';
import { colorScheme } from '../../theme';

interface Props {
  relative?: boolean;
}

export const Viewport = styled.div<Props>`
  height: ${measures.viewportHeight};
  overflow: auto;
  flex: 1;
  width: 100%;
  background-color: ${colorScheme.globalBackground};
  position: ${({ relative }) => (relative ? 'relative' : 'static')};
`;
